/**
 * PLACEHOLDER GL-7 consent copy (spec D6). The version id pins the exact copy
 * shown at grant time and travels to the server as `consentVersion`; it MUST
 * match the BE pin (QLearn-service GlConsentController.CONSENT_COPY_VERSION and
 * the resources file src/main/resources/gl-consent/<version>.en.json).
 *
 * The customer-facing copy speaks for the business and is OWNER-GATED: route the
 * owner-decision-packet and supersede this module (new version id, BOTH repos)
 * before the consent-surface activation. Building against placeholder copy is the
 * spec's explicit instruction — the surface does not wait on the ratified copy,
 * the flip does.
 */
export const GL_CONSENT_COPY_VERSION = "gl-consent-copy-v0-placeholder";

export const glConsentCopy = {
  title: "[PLACEHOLDER] Guided Learning (beta)",
  body:
    "[PLACEHOLDER] When Guided Learning is on for you, QLearn prompts you to " +
    "explain your reasoning before revealing an answer, offers hints, and builds " +
    "review cards from your reasoning. Short reasoning excerpts are stored on your " +
    "own review cards. Your reasoning text never enters analytics.",
  revokeConfirm:
    "[PLACEHOLDER] Turn off Guided Learning? Your Guided Learning review cards and " +
    "drafts will be deleted. You can turn it back on later, which starts a fresh, " +
    "empty deck.",
  error: "[PLACEHOLDER] Something went wrong — please try again later.",
};
